export default __webpack_public_path__ + "static/HES-SO_INTERVIEWS_SIMON-41b4319fd5097e697ff0818198a34416.jpg";